import React from "react";
import InfoTable from "../../components/tables/InfoTable";
import CustomDialog from "../../components/layouts/common/CustomDialog";
import { useDispatch } from "react-redux";
import { closeModal } from "../../store/actions/modalAction";
import { Box, Card, CircularProgress, Grid, Typography } from "@mui/material";
import { CenteredBox } from "../../components/layouts/OneViewBox";
import { InformationUI } from "../../components/InformationUI";

const DataView = ({ TableData, TableTitle, tableKey, indexNo }) => {
  const isRawMaterials = tableKey === "rawMaterials";

  const getColumnSize = (column) => {
    if (isRawMaterials && indexNo) {
      return { sr: 2, name: 4, code: 3, qty: 3 }[column];
    }

    if (isRawMaterials) {
      return { name: 5, code: 3, qty: 4 }[column];
    }

    if (indexNo) {
      return { sr: 2, name: 5, qty: 5 }[column];
    }

    return { name: 6, qty: 6 }[column];
  };

  if (!TableData || !TableTitle) return null;

  return (
    <Box p={2} sx={{ border: "1px solid rgba(0,0,0,0.2)", borderRadius: 2 }}>
      <Box p={2}>
        <Typography fontWeight="bold" variant="h6">
          {TableTitle}
        </Typography>
      </Box>

      {/* Header */}
      <Card sx={{ mb: 2, p: 2, backgroundColor: "rgba(0,0,0,0.08)" }}>
        <Grid container alignItems="center" spacing={3}>
          {indexNo && (
            <Grid item xs={getColumnSize("sr")} textAlign="center">
              <Typography fontWeight="bold">Sr No</Typography>
            </Grid>
          )}

          <Grid item xs={getColumnSize("name")} textAlign="center">
            <Typography fontWeight="bold">Name</Typography>
          </Grid>

          {isRawMaterials && (
            <Grid item xs={getColumnSize("code")} textAlign="center">
              <Typography fontWeight="bold">Code</Typography>
            </Grid>
          )}

          <Grid item xs={getColumnSize("qty")} textAlign="center">
            <Typography fontWeight="bold">Min Of Quantity Required</Typography>
          </Grid>
        </Grid>
      </Card>

      {/* Rows */}
      {TableData.map((item, index) => (
        <Card key={index} sx={{ mb: 2, p: 2 }}>
          <Grid container alignItems="center" spacing={3}>
            {indexNo && (
              <Grid item xs={getColumnSize("sr")} textAlign="center">
                <Typography variant="body2">{index + 1}</Typography>
              </Grid>
            )}

            <Grid item xs={getColumnSize("name")} textAlign="center">
              <Typography variant="body2">{item?.name}</Typography>
            </Grid>

            {isRawMaterials && (
              <Grid item xs={getColumnSize("code")} textAlign="center">
                <Typography variant="body2">{item?.code}</Typography>
              </Grid>
            )}

            <Grid item xs={getColumnSize("qty")} textAlign="center">
              <Typography variant="body2">{item?.min_of_quantity}</Typography>
            </Grid>
          </Grid>
        </Card>
      ))}
    </Box>
  );
};

const SemiKnockDownInfoUi = ({ data, loading }) => {
  const dispatch = useDispatch();

  return (
    <CustomDialog
      id={"infoupdatee"}
      title={"Semi knock Down"}
      closeText="Close"
      onClose={() => dispatch(closeModal("infoupdatee"))}
    >
      {loading ? (
        <CenteredBox>
          {" "}
          <CircularProgress />{" "}
        </CenteredBox>
      ) : (
        <>
          <InformationUI
            Data={[
              { label: "SKD Name :", value: data?.name },
              { label: "SKD Code :", value: data?.skd_Code || "NA" },
              {
                label: "Special Marking :",
                value: data?.specialMarking?.name || "NA",
              },
            ]}
          />
          {data?.rawMaterials?.length > 0 && (
            <Box mb={2}>
              <DataView
                TableTitle={"Raw Materials"}
                TableData={data?.rawMaterials}
                tableKey="rawMaterials"
                indexNo={true}
              />
            </Box>
          )}
        </>
      )}
    </CustomDialog>
  );
};

export default SemiKnockDownInfoUi;
